import { useMutation } from '@tanstack/react-query';
import { idPortenSignIn, IdPortenSignInParameters, IdPortenSignInResult } from 'src/api/authAPI';
import ApiError from 'src/api/errorHandling/ApiError';

export default function useIdPortenSignIn(onSuccess: (data: IdPortenSignInResult) => void) {
  return useMutation<IdPortenSignInResult, ApiError, IdPortenSignInParameters>({
    mutationFn: idPortenSignIn,
    onSuccess,
    onSettled: () => {
      sessionStorage.removeItem('idPortenLoginState');
      sessionStorage.removeItem('idPortenCodeVerifier');
      sessionStorage.removeItem('verificationGuid');
    },
  });
}
